import { render, staticRenderFns } from "./SubSection.vue?vue&type=template&id=aca4891c&scoped=true&"
import script from "./SubSection.vue?vue&type=script&lang=js&"
export * from "./SubSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca4891c",
  null
  
)

export default component.exports